export default __webpack_public_path__ + "static/media/date-picker-chevron.f5f5b685.svg";